import request from '@/utils/axios'

//获取区域列表根据父id(工作人员)
export function GetAreaListByPId(id) {
  return request({
    url: `/Area/GetAreaListByPId?id=${id}`,
    method: "get"
  })
}

// 添加预约管理时获取接口(工作人员)
export function GetMyJurisdictionArea(id) {
  return request({
    url: `/Area/GetMyJurisdictionArea?id=${id}`,
    method: "get"
  })
}

//获取区域列表根据父id(设计公司/普通用户)
export function GetAreaListByPId2(id) {
  return request({
    url: `/Area/GetAreaListByPId2?id=${id}`,
    method: "get"
  })
}

// 添加区域(工作人员)
export function Add(params) {
  return request({
    url: '/Area/AddArea',
    method: "post",
		data:params
  })
}

// 删除区域(工作人员)
export function DeleArea(id) {
  return request({
    url: `/Area/DeleArea?id=${id}`,
    method: "get"
  })
}
